import { ErrorTypes } from '../../types/ErrorTypes';
import { FormError } from '../../types/FormError';

export const formErrorMap: { [key in ErrorTypes]: FormError } = {
  [ErrorTypes.ForetagNotFound]: {
    severity: 'warning',
    text: 'Inget företag med det organisationsnumret hittades',
  },
  [ErrorTypes.FastighetsinnehavNotFound]: {
    severity: 'info',
    text: 'Inga fastigheter funna för organisationen',
  },
  [ErrorTypes.Forbidden]: {
    severity: 'error',
    text: 'Ditt avtal saknar stöd för denna transaktion',
  },
  [ErrorTypes.ValidationFailed]: {
    severity: 'warning',
    text: 'Fyll i organisationsnummer på formatet NNNNNN-NNNN',
  },
  [ErrorTypes.LegallyUnavailable]: {
    severity: 'warning',
    text: 'Ej tillåtet att visa fastighetsinnehav för den aktuella organisationen',
  },
  [ErrorTypes.GatewayTimeout]: {
    severity: 'error',
    text: 'Okänt fel',
  },
  [ErrorTypes.UnknownError]: {
    severity: 'error',
    text: 'Okänt fel',
  },
};
